import { createStore, applyMiddleware, Store } from 'redux';
import { createWrapper, MakeStore } from 'next-redux-wrapper';
import { thunk } from 'redux-thunk';
import { rootReducer } from './root';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const makeStore: MakeStore<any> = () => {
    return createStore(rootReducer, applyMiddleware(thunk));
};

export const wrapper = createWrapper<AppStore>(makeStore, {
    debug: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = Store<RootState>;
export type AppDispatch = AppStore['dispatch'];
